/** Plain-text → safe HTML for legacy blocks; leave existing HTML as-is. */
export default function richTextInitialHtml(raw) {
  const text = raw ?? ""
  if (!text) return ""
  if (/<[a-z][\s\S]*>/i.test(text)) return text
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML.replace(/\r\n|\r|\n/g, "<br>")
}
